<h3 [ngStyle]="{'color': getPrimaryColor()}">กรุณายืนยันตัวตน</h3>
<div class="uk-flex uk-flex-center">
    @if(model().form.mobile) {
        <p class="uk-text-center uk-text-meta">
            ระบบได้ส่ง SMS รหัส OTP ไปยัง<br />เบอร์มือถือ
            <strong>{{model().form.mobile|moblieOtpPipe}}</strong>
        </p>
    }
</div>
<p class="uk-text-center uk-text-mute uk-margin-small-bottom uk-margin-remove-top"><small>รหัสอ้างอิง : <strong>{{otpRef()}}</strong></small></p>
<div class="uk-flex uk-flex-center">
    <ng-otp-input placeholder="t" #ngOtpInput [config]="{length:6, inputClass: 'uk-input', allowNumbersOnly: true}" (onInputChange)="onOtpChange($event);"></ng-otp-input>
</div>
<p class="uk-text-center uk-text-danger uk-margin-remove uk-animation-fast uk-form-controls.error" [ngClass]="{'uk-animation-fade': invalidOTP()}">
    <small>รหัส OTP ไม่ถูกต้อง</small>
</p>
<div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
    <button type="submit"
        class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
        [ngStyle]="{'background-color': getPrimaryColor()}"
        [disabled]="checkDisabled()" (click)="onSubmit()">{{btnSubmitText()}}
    </button>
</div>
<p class="uk-text-center uk-margin-remove">
    <span class="uk-text-meta uk-margin-small-right">หากไม่ได้รับรหัส OTP</span>
    <a class="uk-text-meta uk-margin-small-right" (click)="resendOTP()"><u>ขอรับรหัสใหม่</u></a>
    @if (countdown()) {
        <span class="uk-text-danger"><b>{{countdown()}}</b></span>
    }
</p>